/** Shared dark-theme tokens for Sleep Report UI (matches 6MWT / report.module.css). */

export const sleepTheme = {
    text: "var(--primary-text-color)",
    textMuted: "var(--primary-text-color-80)",
    accent: "var(--primary-theme-color)",
    surface: "var(--primary-popup-background-color)",
    stroke: "var(--primary-popup-stroke-color)",
    teamsSurface: "var(--teams-content-surface)",
    buttonText: "var(--primary-button-text-color)",
    chartText: "#ffffff",
    chartTextMuted: "rgba(255, 255, 255, 0.55)",
    chartGrid: "rgba(255, 255, 255, 0.14)",
    chartAxisBorder: "rgba(255, 255, 255, 0.22)",
    spo2Line: "#6B9FFF",
    hrLine: "#F2A100",
};

export const sleepLabelStyle = {
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: 500,
    color: sleepTheme.text,
    marginBottom: "4px",
};

export const sleepSectionLabelStyle = {
    ...sleepLabelStyle,
    fontWeight: 600,
    marginBottom: "8px",
};

export const sleepSubLabelStyle = {
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: 400,
    color: sleepTheme.text,
    marginBottom: 0,
    width: "48px",
    flexShrink: 0,
};

export const sleepValueStyle = {
    fontFamily: "Poppins",
    fontSize: "16px",
    color: sleepTheme.text,
    lineHeight: 1.4,
};

export const sleepCardStyle = {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    flexWrap: "wrap",
    justifyContent: "center",
    padding: "20px 24px",
    backgroundColor: sleepTheme.surface,
    borderRadius: "15px",
    border: `1px solid ${sleepTheme.stroke}`,
};

export const sleepIconCircleStyle = {
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: sleepTheme.accent,
    color: sleepTheme.buttonText,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

export const sleepOutlineButtonStyle = {
    color: sleepTheme.accent,
    padding: "8px 24px",
    border: `1px solid ${sleepTheme.accent}`,
    borderRadius: "8px",
    textTransform: "none",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    backgroundColor: "transparent",
};

export const sleepPrimaryButtonStyle = {
    backgroundColor: sleepTheme.accent,
    color: sleepTheme.buttonText,
    padding: "8px 24px",
    border: `1px solid ${sleepTheme.accent}`,
    borderRadius: "8px",
    textTransform: "none",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
};

export const sleepChartFrameStyle = {
    width: "95%",
    maxWidth: "95%",
    height: "280px",
    borderRadius: "8px",
    border: `1px solid ${sleepTheme.stroke}`,
    backgroundColor: sleepTheme.surface,
    padding: "10px 8px",
};

export const sleepChartScaleStyle = {
    ticks: {
        color: sleepTheme.chartTextMuted,
        font: { family: "Poppins", size: 11 },
    },
    grid: { color: sleepTheme.chartGrid },
    border: { color: sleepTheme.chartAxisBorder },
};

export const sleepChartAxisTitle = (text, color = sleepTheme.chartText) => ({
    display: true,
    text,
    color,
    font: { family: "Poppins", size: 12, weight: "bold" },
});

/** Drop-episode / data tables on dark modal surfaces */
export const sleepTableTheme = {
    frameBg: "var(--teams-content-surface)",
    headerBg: "rgba(255, 255, 255, 0.1)",
    rowBg: "var(--teams-content-surface)",
    rowAltBg: "rgba(255, 255, 255, 0.05)",
    cellBorder: "rgba(255, 255, 255, 0.16)",
    headerBorder: "rgba(255, 255, 255, 0.24)",
};

export const sleepTableFrameStyle = {
    borderRadius: "8px",
    border: `1px solid ${sleepTheme.stroke}`,
    overflow: "hidden",
    backgroundColor: sleepTableTheme.frameBg,
};
